// extracted by mini-css-extract-plugin
module.exports = {"loading-wrap":"components_loading-wrap__2itBW","formItemTip":"components_formItemTip__xDkhk"};